module.exports = __webpack_public_path__ + "img/case-gated-launch.4ac0d373.png";